import React, { useState } from "react";
import { Link, useHistory, Redirect } from "react-router-dom";
import { useUser } from "@dreamchimney/user-context";

import { Helmet } from "react-helmet";
import queryString from "query-string";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import SleeveMini from "~/Components/SleeveMini";
import Pager from "../../Components/Global/Pager";
import FavoriteSleevesContainer from "~/Components/Containers/FavoriteSleevesContainer";

const UserFavoritesPage = ({ match, location }) => {
  let history = useHistory();
  const { state: userState, dispatch } = useUser();

  const chimdir = match.params.chimdir;
  const queryStringParams = queryString.parse(location.search);
  const { page: startPage = 1 } = queryStringParams;
  const [page, setPage] = useState(parseInt(startPage, 10));

  const updatePageCallBack = (toPage) => {
    history.push("?page=" + toPage);
    setPage(toPage);
  };
  const sleevesOwner = userState.user.dir === chimdir;
  if (!sleevesOwner) {
    return (
      <Redirect
        to={{
          pathname: "/",
        }}
      />
    );
  }
  return (
    <div className="page-user">
      <FavoriteSleevesContainer
        chimDir={chimdir}
        page={page}
        render={(result) => {
          const { favorites: sleeves, perPage, total } = result;
          const pages = Math.ceil(total / perPage);
          return (
            <React.Fragment>
              <Helmet>
                <title>Sleevery | Favorites | Dream Chimney</title>
              </Helmet>
              <Row>
                <Col xs={12}>
                  <h1 className="page-header">
                    <i className="fa fa-tags"></i> My Favorite Sleeves
                  </h1>
                </Col>
                <Col xs={12}></Col>
              </Row>

              <Row>
                {sleeves.length === 0 && (
                  <Col xs={12}>
                    <p>You dont have any favorite sleeves, yet. </p>
                    <p>
                      <Link to="/sleeves/list">Browse the sleeves</Link> and click the heart icon <i className="far fa-heart"></i> to add a
                      sleeve to your favorites.
                    </p>
                  </Col>
                )}

                <Col xs={12}>
                  <ul className="results cover-wall">
                    {sleeves.length !== 0 &&
                      sleeves.map((sleeve) => (
                        <li key={sleeve.id}>
                          <SleeveMini sleeve={sleeve} />
                        </li>
                      ))}
                  </ul>
                </Col>

                {sleeves.length !== 0 && (
                  <Col xs={12}>
                    <div style={{ padding: "20px 0" }}>
                      <Pager className="pagination-footer" page={page} pages={pages} updatePage={updatePageCallBack} />
                    </div>
                  </Col>
                )}
              </Row>
            </React.Fragment>
          );
        }}
      />
    </div>
  );
};

export default UserFavoritesPage;
